export enum SubscriptionType {
    TNA_COMPLIANCE = 'TNACompliance',
    IHD = 'IHD',
}
